export default "/images/vendor/flag-icon-css/flags/1x1/tv.svg?3ba10c54812d768dc48e6dff41e04b93";